export default __webpack_public_path__ + "bb9977c616aaa1db56ce4b17def1add3.webp";